import BlueButton from '../../components/blue-button';
import CountUp from '../../components/countup';
import {useRef} from 'react';
import {useDispatch} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {navigate} from '../../../utils/navigation';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';

import TapIcon from './tap-icon';
import AddIcon from './add-icon';

export default ({index}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__bounceInUp');
            modal.current.classList.add('animate__bounceOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('telegram-push')); 
            
            if(trigger === 'close')
                closePromotionModal('telegram-push');
            else
                clickPromotionModal('telegram-push', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix telegram-push">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__bounceInUp animate__faster" ref={modal}>
                    <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => closeAction('close')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="telegram-push-image">
                                <div className="telegram-push-notification animate__delay-1s animate__animated animate__fadeInDown">
                                    <div className="image"></div>
                                    <div className="details">
                                        <div className="notification-title">Deposit boost</div>
                                        <div className="notification-text">Take 50% by clicking on the notification</div>
                                    </div>
                                </div>
                            </div>
                            <div className="telegram-push-title">Get more bonuses<br/>with <span>Push</span> notifications</div>
                            <div className="telegram-push-text">1. Open <span>{window.location.host}</span> in your browser</div>
                            <div className="telegram-push-text">2. Add Lucksy to <AddIcon /> <span>Home Page</span></div>
                            <div className="telegram-push-text">3. Login and subscribe to <span>push notifications</span></div>
                            <BlueButton onClick={e => {
                                closeAction('click', () => {
                                    window.open(window.location.origin, '_blank');
                                });
                            }}>Open Web Version</BlueButton>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}